import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/material",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "material-page",
        component: () => import("@/views/Product/ProductPage.vue"),
        meta: {
          title: "Material",
          titleLocalizationCode: "Material",
          desc: "Material page",
          descLocalizationCode: "Material_Page",
          sidebarElement: false,
          permissionCodes: [
            "Product.Read",
            "Product.Add",
            "Product.Edit",
            "Product.Delete",
          ],
        },
      },
    ],
  },
];
